import React, { useState } from 'react';
import moment from 'moment';

export const SelectEnums = {
    REFRESH: 'REFRESH',
};

export const DATE_SHORTCUTS = {
    today: () => moment(),
    tomorrow: () => moment().add(1, 'days'),
    yesterday: () => moment().subtract(1, 'days'),
    'next week': () => moment().add(1, 'weeks'),
    'last week': () => moment().subtract(1, 'weeks'),
    'next month': () => moment().add(1, 'months'),
    'last month': () => moment().subtract(1, 'months'),
    'next year': () => moment().add(1, 'years'),
    'last year': () => moment().subtract(1, 'years'),
    monday: () => moment().day(1),
    tuesday: () => moment().day(2),
    wednesday: () => moment().day(3),
    thursday: () => moment().day(4),
    friday: () => moment().day(5),
    saturday: () => moment().day(6),
    sunday: () => moment().day(0),
    'end of week': () => moment().endOf('week'),
    'start of week': () => moment().startOf('week'),
    'end of month': () => moment().endOf('month'),
    'start of month': () => moment().startOf('month'),
    'end of year': () => moment().endOf('year'),
    'start of year': () => moment().startOf('year'),
};

export const TypableDateInput = ({
    value,
    onChange,
    onBlur,
    min,
    max,
    disabled,
    readOnly,
    placeholder = 'mm/dd/yyyy',
    format = 'MM/DD/YYYY',
}) => {
    const [typedStr, setTypedStr] = useState('');
    const [isTyping, setIsTyping] = useState(false);

    return (
        <input
            type="text"
            className="rs-input date-text-input"
            style={{
                border: 'none',
                outline: 'none',
                background: 'transparent',
                width: '85px',
                color: '#575757',
                boxShadow: 'none',
            }}
            disabled={disabled || readOnly}
            placeholder={placeholder}
            value={isTyping ? typedStr : value ? moment.utc(value).format(format) : ''}
            onFocus={() => {
                setIsTyping(true);
                setTypedStr(value ? moment.utc(value).format(format) : '');
            }}
            onChange={(e) => {
                let val = e.target.value;

                if (val.length > typedStr.length) {
                    if (/^[\d/]+$/.test(val)) {
                        val = val.replace(/\/\/+/g, '/');
                        if (val.length === 2 && /^\d{2}$/.test(val)) {
                            val += '/';
                        } else if (val.length === 5 && /^\d{2}\/\d{2}$/.test(val)) {
                            val += '/';
                        } else if (/^\d{3,8}$/.test(val)) {
                            let month = val.slice(0, 2);
                            let day = val.slice(2, 4);
                            let year = val.slice(4, 8);
                            val = month + (day ? '/' + day : '') + (year ? '/' + year : '');
                        }
                    }
                }

                setTypedStr(val);

                const lowerVal = val.toLowerCase();
                let foundDate = null;
                for (const [key, dateFunc] of Object.entries(DATE_SHORTCUTS)) {
                    if (lowerVal.endsWith(key)) {
                        foundDate = dateFunc();
                        break;
                    }
                }

                // Inline standard formatting check for continuous formats or slashes
                if (!foundDate && val.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
                    const parsed = moment(val, ['MM/DD/YYYY', 'M/D/YYYY'], true);
                    if (parsed.isValid()) foundDate = parsed;
                }

                if (foundDate) {
                    const dateObj = foundDate.toDate();
                    // Compare calendar days, not instants: `new Date('YYYY-MM-DD')` is UTC midnight, which
                    // west of UTC is the previous evening and wrongly rejects the `max` day itself.
                    const day = foundDate.format('YYYY-MM-DD');
                    const isWithinRange =
                        (!min || day >= moment.utc(min).format('YYYY-MM-DD')) && (!max || day <= moment.utc(max).format('YYYY-MM-DD'));

                    if (isWithinRange && dateObj.getFullYear() <= 2045) {
                        const formattedDate = foundDate.format('YYYY-MM-DD');
                        if (onChange) onChange(formattedDate);
                        setTypedStr(foundDate.format(format));
                    }
                } else {
                    if (val === '') {
                        if (onChange) onChange(null);
                    }
                }
            }}
            onBlur={(e) => {
                setIsTyping(false);
                let val = e.target.value.trim();
                if (val !== '') {
                    let parsed = moment(val, ['MM/DD/YYYY', 'M/D/YYYY', 'MMDDYYYY', 'MDDYYYY', 'MMDDYY', 'YYYY-MM-DD'], false);
                    if (parsed.isValid()) {
                        const dateObj = parsed.toDate();
                        const minDate = min ? new Date(min) : null;
                        const maxDate = max ? new Date(max) : null;
                        const isWithinRange = (!minDate || dateObj >= minDate) && (!maxDate || dateObj <= maxDate);
                        if (isWithinRange && dateObj.getFullYear() <= 2045) {
                            const formattedDate = parsed.format('YYYY-MM-DD');
                            if (onChange) onChange(formattedDate);
                        }
                    }
                }
                if (onBlur) onBlur();
            }}
        />
    );
};
